import {Action} from '@ngrx/store';
import {Group} from '../../../models/group';

export class GetGroupsSuccessAction implements Action {
  public static readonly type = 'GetGroupsSuccessAction';

  constructor(public groups: Group[]) {
  }

  public type = GetGroupsSuccessAction.type;
}
